import {useKeycloak} from "@react-keycloak/web";
import {useNavigate} from "react-router-dom";
import {useContext} from "react";

const PrivateRoute = ({ children }) => {

    const navigate = useNavigate();

    const { keycloak } = useKeycloak();

    const isLoggedIn = keycloak.authenticated;

    let org_id = null;
    if (keycloak.resourceAccess && keycloak.resourceAccess.portal_client && keycloak.resourceAccess.portal_client.roles) {
        org_id = keycloak.resourceAccess.portal_client.roles;
    }

    if (Array.isArray(org_id) && org_id.length > 1) {
        console.log("More than one OrgID!")
        org_id = null;
    } else {
        console.log(org_id);
        console.log("One OrgID!");
    }

    if(isLoggedIn) {
        if(org_id == null) {
            navigate('/login');
            console.log("Redirecting! You need to to have one OrgID!: " + isLoggedIn);
            keycloak.logout();
        }
        return isLoggedIn ? children : null;
    } else {
        navigate('/login');
        console.log("Redirecting! You need to be logged in to access this page.: " + isLoggedIn);
        return null;
    }
};

export const useAuthData = () => useContext()

export default PrivateRoute;
